import React from 'react';
import { Modal } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';
import moment from 'moment';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class SpecialAvailabilityModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: false,
                specialAvailabilityType: opts.specialAvailabilityType,
                notes: opts.notes,
                hasMultipleTypes: opts.hasMultipleTypes,
                hasMultipleNotes: opts.hasMultipleNotes
            });
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async saveAndClose() {
        const { specialAvailabilityType, notes } = this.state;
        this.close();
        this.resolve({
            specialAvailabilityType,
            notes
        });
    }

    //------------------------------------------------------------------------------

    render() {
        const {
            isOpen,
            isLoading
        } = this.state;

        if (!isOpen) {
            return null;
        }
        
        return (
            <Modal show className="special-availability-modal">
                <form onSubmit={e => {
                    e.preventDefault();
                    this.saveAndClose();
                }}>
                    {isLoading ? <Modal.Body><Loader /></Modal.Body> : this.renderInner()}
                </form>
            </Modal>
        );
    }

    renderInner() {
        const {
            specialAvailabilityType,
            notes,
            hasMultipleTypes,
            hasMultipleNotes
        } = this.state;

        return (<>
            <Modal.Body>

                {hasMultipleTypes &&
                    <div className="alert alert-danger mb-3">
                        The date range you have selected has multiple conflicting types. 
                        Pressing save will override them all.
                    </div>
                }

                <div className="form-group mb-3">
                    <label className="form-label">Special availability type</label>
                    <select
                        className="form-control"
                        value={specialAvailabilityType || ''}
                        onChange={e => this.setState({ specialAvailabilityType: e.target.value })}
                    >
                        <option value="">(None)</option>
                        <option value="DefinitelyNotAvailable">Definitely not available</option>
                        <option value="StealthVendor">Stealth: Vendor</option>
                        <option value="StealthOther">Stealth: Other</option>
                    </select>
                </div>

                {hasMultipleNotes &&
                    <div className="alert alert-danger mb-3">
                        The date range you have selected has multiple conflicting notes.
                        Pressing save will override them all.
                    </div>
                }

                <div className="form-group">
                    <label className="form-label">Notes</label>
                    <ExpandingTextArea
                        className="form-control"
                        value={notes || ''}
                        onChange={e => this.setState({ notes: e.target.value })}
                        rows={4}
                    />
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary me-auto" onClick={e => this.close()}>
                    Cancel
                </button>
                <button type="submit" className="btn btn-primary ms-auto">
                    Save
                </button>
            </Modal.Footer>
        </>);
    }

}

export default SpecialAvailabilityModal;